var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcLoading = function SvgIcLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0h4v8h-4z",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: 0,
    dur: "1s",
    from: 1,
    repeatCount: "indefinite",
    to: 0.1
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m25.9 3.272 2.828 2.829-5.657 5.656-2.828-2.828z",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0.125s",
    dur: "1s",
    from: 1,
    repeatCount: "indefinite",
    to: 0.1
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 14v4h-8v-4z",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0.25s",
    dur: "1s",
    from: 1,
    repeatCount: "indefinite",
    to: 0.1
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m28.728 25.9-2.829 2.828-5.656-5.657 2.828-2.828z",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0.375s",
    dur: "1s",
    from: 1,
    repeatCount: "indefinite",
    to: 0.1
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 32h-4v-8h4z",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0.5s",
    dur: "1s",
    from: 1,
    repeatCount: "indefinite",
    to: 0.1
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m6.1 28.728-2.828-2.829 5.657-5.656 2.828 2.828z",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0.675s",
    dur: "1s",
    from: 1,
    repeatCount: "indefinite",
    to: 0.1
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 18v-4h8v4z",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0.75s",
    dur: "1s",
    from: 1,
    repeatCount: "indefinite",
    to: 0.1
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m3.272 6.1 2.829-2.828 5.656 5.657-2.828 2.828z",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0.875s",
    dur: "1s",
    from: 1,
    repeatCount: "indefinite",
    to: 0.1
  }))));
};
export default SvgIcLoading;